<template>
    <div class="ctw-px-4 ctw-pt-4">
        <form @submit.prevent="sendMessage" class="chat-container">
            <div class="ctw-text-red-400 ctw-font-bold ctw-pl-1 ctw-text-xs ctw-absolute ctw--mt-4" v-if="errorMsg">
                {{ errorMsg }}
            </div>
            <div class="ctw-relative">
                <input id="prompt-textarea" type="text" :placeholder="isThinking ? 'Auf Antwort warten...' : 'Sende eine Nachricht'"
                    :disabled="isThinking"
                    class="cierra-chat-input ctw-peer"
                    v-model="message"
                    autocomplete="off"
                    autofocus="autofocus" />
                <button 
                    type="submit"
                    class="           
                        ctw-absolute ctw-top-1/2 ctw-right-0 -ctw-translate-y-1/2
                        ctw-p-2 ctw-border-0 ctw-rounded-md
                        peer-placeholder-shown:ctw-text-white/40 ctw-text-white ctw-bg-transparent ctw-transition-colors 
                        hover:ctw-bg-white12 hover:ctw-text-white 
                        disabled:ctw-text-gray-400 disabled:ctw-opacity-40
                        enabled:ctw-bg-brand
                        dark:disabled:hover:ctw-bg-transparent
                    "
                >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" class="ctw-h-4 ctw-w-4 ctw-m-1 md:ctw-m-0" stroke-width="2">
                        <path fill="currentColor" d="M.5 1.163A1 1 0 0 1 1.97.28l12.868 6.837a1 1 0 0 1 0 1.766L1.969 15.72A1 1 0 0 1 .5 14.836V10.33a1 1 0 0 1 .816-.983L8.5 8 1.316 6.653A1 1 0 0 1 .5 5.67V1.163Z"></path>
                    </svg>
                </button>
            </div>
        </form>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import lang from '../../lang.js';
import { useConversationStore } from '@/store/conversation';

const selectedLang = window.CierraChatWidget ? window.CierraChatWidget.lang : 'de';
const langData = lang[selectedLang];

const conversationStore = useConversationStore();

const isThinking = computed(() => conversationStore.isThinking);

const errorMsg = ref(null);
const message = ref('');
const sendMessage = () => {
    if(isThinking.value) {
        return;
    }
    // message should be filled but not longer than 100 chars
    if (message.value.length === 0) {
        errorMsg.value = langData['message-empty'];
        return;
    }
    if (message.value.length > 200) {
        errorMsg.value = langData['message-too-long'];
        return;
    }
    conversationStore.sendMessage(message.value);
    errorMsg.value = null;
    message.value = '';
}
</script>

<style scoped>
.cierra-chat-input {
    @apply  ctw-block ctw-w-full ctw-py-2 ctw-pl-3 ctw-pr-9
            ctw-bg-white6 ctw-text-white
            md:ctw-text-sm
            ctw-border ctw-border-solid ctw-border-white6 ctw-rounded-md
            placeholder:ctw-text-white/40
            focus:ctw-border-white24 focus:ctw-outline-none;
            
}   
</style>